import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import customerConfig from "emun.customer/customer.config";
import customerPicker from "emun.customer/picker/customer-picker";
import resolve from 'ioc/resolve'

export const badgeResults = {
	"Id": "2157",
	"Title": "",
	"FirstName": "Joe",
	"LastName": "Smith",
	"EmailAddress": "orders@24estyle.com",
	"WebsiteUri": "www.showcare.com",
	"Address": {
		"Address1": "24 E BROUGHTON ST",
		"Address2": null,
		"City": "SAVANNAH",
		"Company": "24E DESIGN CO",
		"CountryCode": "US",
		"PostalCode": "31401",
		"ProvinceCode": "GA"
	},
	"Responses": [
		{
			"Question": "Company Type",
			"Answers": [
				"Buyer"
			]
		},
		{
			"Question": "Business Type",
			"Answers": [
				"Carpet/Rugs"
			]
		},
		{
			"Question": "Price Point",
			"Answers": [
				"Upper End"
			]
		},
		{
			"Question": "Volume",
			"Answers": [
				"Under .5 Million"
			]
		}
	]
};

export default class ScanBadgeController {
	constructor(options, retailerPrompt) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.clearBadge();
		$ctrl.prompt = retailerPrompt;
		$ctrl.customerConfig = customerConfig;
		$ctrl.busy = false;
	}

	clearBadge() {
		const $ctrl = this;
		$ctrl.badge = {};
		$ctrl.match = {};
		$ctrl.matches = [];
		$ctrl.scannedBadge = "";
		$ctrl.finished = false;
		$ctrl.$emit("badge-processed");
		$ctrl.bus.validationErrors = [];
	}
	lookup() {
		const $ctrl = this;
		return customerPicker({
			title: "Lookup Customer...",
			view: "table",
			backdrop: false,
			placement: "center",
			single: true,
			criteria: {
				Status: 'Active'
			}
		}).then((result) => {
			$ctrl.match = result;
			$ctrl.bus.send('QueryRetailers.json?Id=' + result.id).then(function (res) {
				$ctrl.finished = true;
				$ctrl.matches = res.data.results;
				if ($ctrl.matches.length === 1) $ctrl.match = $ctrl.matches[0];
			});
		});

	}
	getBadge(badgeNum) {
		const $ctrl = this;
		if ($ctrl.$session.meta["BadgeScanProvider"] == "ShowCare") $ctrl.getShowCareBadge(badgeNum);
		if ($ctrl.$session.meta["BadgeScanProvider"] == "XPress Leads") $ctrl.getXPressBadge(badgeNum);
	}
	getShowCareBadge(badgeNum) {
		const $ctrl = this;
		$ctrl.bus.validationErrors = [];
		$ctrl.badge = {};
		$ctrl.match = {};
		$ctrl.matches = [];
		$ctrl.finished = false;
		if (badgeNum.indexOf("|") != -1) badgeNum = badgeNum.substring(0, badgeNum.indexOf("|"));
		if (badgeNum.indexOf("]") != -1) badgeNum = badgeNum.substring(0, badgeNum.indexOf("]"));
		resolve('$http').get("https://www.showlead.com/api/v1/get-token", {
			headers: { 'Pragma': undefined, 'Cache-Control': undefined, 'X-Requested-With': undefined, 'If-Modified-Since': undefined },
			method: "GET",
			params: {
				"id": $ctrl.$session.meta["BadgeScanApiKey"], // $ctrl.customerConfig.showCareApiKey, //"176A-3915-A568-21C4",
				"deviceName": "emun1"
			}
		}).then(res => {
			$ctrl.busy = true;
				var token = res.data;
			resolve('$http').get("https://www.showlead.com/api/v1/get-customer", {
				headers: { 'Pragma': undefined, 'Cache-Control': undefined, 'X-Requested-With': undefined, 'If-Modified-Since': undefined },
				method: "GET",
				params: {
					"token": token,
					"customerId": badgeNum
				}
			}).then(res => {
				$ctrl.busy = false;
				$ctrl.badge = res.data.Customer;
				if ($ctrl.badge) {
					console.debug("Badge Scanned", $ctrl.badge);
					$ctrl.bus.send('CreateBadgeScan.json', {
						BadgeId: $ctrl.badge.Id,
						Data: $ctrl.badge,
						CompanyName: $ctrl.badge.Address.Company,
						FirstName: $ctrl.badge.FirstName,
						LastName: $ctrl.badge.LastName,
						Address: $ctrl.badge.Address.Address1,
						Address2: $ctrl.badge.Address.Address2,
						City: $ctrl.badge.Address.City,
						State: $ctrl.badge.Address.ProvinceCode.replace("US_",""),
						Zip: $ctrl.badge.Address.PostalCode.substring(0,5),
						Country: $ctrl.badge.Address.CountryCode,
						Email: $ctrl.badge.EmailAddress,
						Phone: $ctrl.badge.PhoneNumber
					}).then(() => resolve('$rootScope').$broadcast("badgeScanned"));
					$ctrl.bus.send('QueryRetailers.json', {
						tagCriteria: {
							'Badge': $ctrl.badge.Id
						}
					}).then(function(res) {
						$ctrl.finished = true;
						$ctrl.matches = res.data.results;
						if (!$ctrl.matches.length) {
							if ($ctrl.badge.EmailAddress) {
								$ctrl.bus.send(`QueryRetailers.json?Email=${$ctrl.badge.EmailAddress}`).then(function (res) {
									//$ctrl.finished = true;
									$ctrl.matches = res.data.results;
									if (!$ctrl.matches.length) {
										if ($ctrl.badge.PhoneNumber) {
											$ctrl.bus.send(`QueryRetailers.json?Phone=${$ctrl.badge.PhoneNumber.replace(/\D/g,'')}`).then(function(res) {
												$ctrl.matches = res.data.results;
												if (!$ctrl.matches.length) {
													$ctrl.bus.send('QueryRetailers.json', {
														search: `${$ctrl.badge.Address.Company}`
														// search: `${$ctrl.badge.EmailAddress}*${$ctrl.badge.Address.Company}*${$ctrl.badge.Address.City}*${$ctrl.badge.Address.ProvinceCode.replace('US_', '')}*${$ctrl.badge.Address.PostalCode.substring(0, 5)}`
													}).then(function (res) {
														$ctrl.matches = res.data.results;
														if ($ctrl.matches.length === 1) 
															$ctrl.selectMatch($ctrl.matches[0]);
														$ctrl.finished = true;
													});
												} else if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
												$ctrl.finished = true;
											});
										} else {
											$ctrl.bus.send('QueryRetailers.json', {
												search: `${$ctrl.badge.Address.Company}`
												// search: `${$ctrl.badge.EmailAddress}*${$ctrl.badge.Address.Company}*${$ctrl.badge.Address.City}*${$ctrl.badge.Address.ProvinceCode.replace('US_', '')}*${$ctrl.badge.Address.PostalCode.substring(0, 5)}`
											}).then(function (res) {
												$ctrl.matches = res.data.results;
												if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
												$ctrl.finished = true;
											});
										}
									} else if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
									$ctrl.finished = true;
								});
							} else {
								if ($ctrl.badge.PhoneNumber) {
									$ctrl.bus.send(`QueryRetailers.json?Phone=${$ctrl.badge.PhoneNumber.replace(/\D/g,'')}`).then(function(res) {
										$ctrl.matches = res.data.results;
										if (!$ctrl.matches.length) {
											$ctrl.bus.send('QueryRetailers.json', {
												search: `${$ctrl.badge.Address.Company}`
												// search: `${$ctrl.badge.EmailAddress}*${$ctrl.badge.Address.Company}*${$ctrl.badge.Address.City}*${$ctrl.badge.Address.ProvinceCode.replace('US_', '')}*${$ctrl.badge.Address.PostalCode.substring(0, 5)}`
											}).then(function (res) {
												$ctrl.matches = res.data.results;
												if ($ctrl.matches.length === 1) 
													$ctrl.selectMatch($ctrl.matches[0]);
												$ctrl.finished = true;
											});
										} else if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
										$ctrl.finished = true;
									});
								} else {
									$ctrl.bus.send('QueryRetailers.json', {
										search: `${$ctrl.badge.Address.Company}`
										// search: `${$ctrl.badge.EmailAddress}*${$ctrl.badge.Address.Company}*${$ctrl.badge.Address.City}*${$ctrl.badge.Address.ProvinceCode.replace('US_', '')}*${$ctrl.badge.Address.PostalCode.substring(0, 5)}`
									}).then(function (res) {
										$ctrl.matches = res.data.results;
										if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
										$ctrl.finished = true;
									});
								}
							}
						} else if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
						$ctrl.finished = true;
					});
				} else {
					$ctrl.bus.validationErrors.push([
						{
							errorCode: "-1",
							fieldName: "badge",
							message: res.data.ResultMessage.Messages[0].Text
						}
					]);
				}
			});
		});
//		$ctrl.badge = badgeResults;
	}
	getXPressBadge(badgeNum) {
		const $ctrl = this;
		$ctrl.bus.validationErrors = [];
		$ctrl.badge = {};
		$ctrl.match = {};
		$ctrl.matches = [];
		$ctrl.finished = false;
		$ctrl.arrBadge = badgeNum.split("$");
		$ctrl.scannedBadgeNum = $ctrl.arrBadge[0];
		var lastName = $ctrl.arrBadge[3];
		$ctrl.busy = true;

		$ctrl.bus.send("ScanXPressLeadsProBadge.json", {
			AuthKey: $ctrl.$session.meta["BadgeScanApiKey"],
			ExId: $ctrl.$session.meta["BadgeScanExhibitorId"],
			EventCode: $ctrl.$session.meta["BadgeScanEventCode"],
			Badge: $ctrl.scannedBadgeNum,
			LastName: lastName	
		}).then(res => {
			console.debug("BL*** badge", res.data);
			$ctrl.busy = false;
			$ctrl.badge = res.data.Results;
			if ($ctrl.badge) {
				$ctrl.badge.id = $ctrl.badge.Id = $ctrl.scannedBadgeNum;
				console.debug("Badge Scanned", $ctrl.badge);
				$ctrl.bus.send('CreateBadgeScan.json', {
					BadgeId: $ctrl.scannedBadgeNum,
					Data: $ctrl.badge,
					CompanyName: $ctrl.badge.Company,
					FirstName: $ctrl.badge["First Name"],
					LastName: $ctrl.badge["Last Name"],
					Address: $ctrl.badge.Address,
					Address2: $ctrl.badge["Address 2"],
					City: $ctrl.badge.City,
					State: $ctrl.badge.State,
					Zip: $ctrl.badge.Zipcode,
					Country: $ctrl.badge.Country,
					Email: $ctrl.badge.Email,
					Phone: $ctrl.badge.Phone,
					Provider: $ctrl.$session.meta["BadgeScanProvider"]
				}).then(() => resolve('$rootScope').$broadcast("badgeScanned"));
				$ctrl.bus.send('QueryRetailers.json', {
					tagCriteria: {
						'Badge': $ctrl.scannedBadgeNum
					}
				}).then(function(res) {
					$ctrl.finished = true;
					$ctrl.matches = res.data.results;
					if (!$ctrl.matches.length) {
						if ($ctrl.badge.Email) {
							$ctrl.bus.send(`QueryRetailers.json?Email=${$ctrl.badge.Email}`).then(function (res) {
								//$ctrl.finished = true;
								$ctrl.matches = res.data.results;
								if (!$ctrl.matches.length) {
									if ($ctrl.badge.Phone) {
										$ctrl.bus.send(`QueryRetailers.json?Phone=${$ctrl.badge.Phone.replace(/\D/g,'')}`).then(function(res) {
											$ctrl.matches = res.data.results;
											if (!$ctrl.matches.length) {
												$ctrl.bus.send('QueryRetailers.json', {
													search: `${$ctrl.badge.Company}`
													// search: `${$ctrl.badge.EmailAddress}*${$ctrl.badge.Address.Company}*${$ctrl.badge.Address.City}*${$ctrl.badge.Address.ProvinceCode.replace('US_', '')}*${$ctrl.badge.Address.PostalCode.substring(0, 5)}`
												}).then(function (res) {
													$ctrl.matches = res.data.results;
													if ($ctrl.matches.length === 1) 
														$ctrl.selectMatch($ctrl.matches[0]);
													$ctrl.finished = true;
												});
											} else if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
											$ctrl.finished = true;
										});
									} else {
										$ctrl.bus.send('QueryRetailers.json', {
											search: `${$ctrl.badge.Company}`
											// search: `${$ctrl.badge.EmailAddress}*${$ctrl.badge.Address.Company}*${$ctrl.badge.Address.City}*${$ctrl.badge.Address.ProvinceCode.replace('US_', '')}*${$ctrl.badge.Address.PostalCode.substring(0, 5)}`
										}).then(function (res) {
											$ctrl.matches = res.data.results;
											if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
											$ctrl.finished = true;
										});
									}
								} else if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
								$ctrl.finished = true;
							});
						} else {
							if ($ctrl.badge.Phone) {
								$ctrl.bus.send(`QueryRetailers.json?Phone=${$ctrl.badge.Phone.replace(/\D/g,'')}`).then(function(res) {
									$ctrl.matches = res.data.results;
									if (!$ctrl.matches.length) {
										$ctrl.bus.send('QueryRetailers.json', {
											search: `${$ctrl.badge.Company}`
											// search: `${$ctrl.badge.EmailAddress}*${$ctrl.badge.Address.Company}*${$ctrl.badge.Address.City}*${$ctrl.badge.Address.ProvinceCode.replace('US_', '')}*${$ctrl.badge.Address.PostalCode.substring(0, 5)}`
										}).then(function (res) {
											$ctrl.matches = res.data.results;
											if ($ctrl.matches.length === 1) 
												$ctrl.selectMatch($ctrl.matches[0]);
											$ctrl.finished = true;
										});
									} else if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
									$ctrl.finished = true;
								});
							} else {
								$ctrl.bus.send('QueryRetailers.json', {
									search: `${$ctrl.badge.Company}`
									// search: `${$ctrl.badge.EmailAddress}*${$ctrl.badge.Address.Company}*${$ctrl.badge.Address.City}*${$ctrl.badge.Address.ProvinceCode.replace('US_', '')}*${$ctrl.badge.Address.PostalCode.substring(0, 5)}`
								}).then(function (res) {
									$ctrl.matches = res.data.results;
									if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
									$ctrl.finished = true;
								});
							}
						}
					} else if ($ctrl.matches.length === 1) $ctrl.selectMatch($ctrl.matches[0]);
					$ctrl.finished = true;
				});
			} else {
				$ctrl.bus.validationErrors.push([
					{
						errorCode: "-1",
						fieldName: "badge",
						message: res.data.Results[0].Message
					}
				]);
			}
		});
	}
	selectMatch(match) {
		const $ctrl = this;
		$ctrl.match = match;
		if ($ctrl.startOrder) $ctrl.linkCustomer();
	}

	linkCustomer() {
		const $ctrl = this;
		if ($ctrl.badge.Id && $ctrl.match.id) {
			if ($ctrl.match.keywords && $ctrl.match.keywords.indexOf($ctrl.badge.id) == -1) 
				$ctrl.match.keywords = $ctrl.match.keywords + "|" + $ctrl.badge.Id;
			if (!$ctrl.match.tags['Badge'] || ($ctrl.match.tags['Badge'] && $ctrl.match.tags['Badge'].indexOf($ctrl.badge.Id) == -1)) {
				$ctrl.match.tags['Badge'] = $ctrl.badge.Id;
			}

			$ctrl.match.keywords = $ctrl.match.keywords + "|" + $ctrl.badge.Id;
			$ctrl.bus.send('UpdateRetailer.json', $ctrl.match).then(function (res) {
				$ctrl.clearBadge();
				if ($ctrl.startOrder) {
					$ctrl.$close(res.data);
				}
			});
		}
	}
	create() {
		const $ctrl = this;
		const request = $ctrl.$session.meta['BadgeScanProvider'] == "ShowCare" ? {
			companyName: $ctrl.badge.Address.Company || $ctrl.badge.Address.CompanyDba,
			address: $ctrl.badge.Address.Address1,
			address2: $ctrl.badge.Address.Address2,
			city: $ctrl.badge.Address.City,
			state: $ctrl.badge.Address.ProvinceCode.replace("US_",""),
			zip: $ctrl.badge.Address.PostalCode.substring(0,5),
			country: $ctrl.badge.Address.CountryCode,
			website: $ctrl.badge.WebsiteUri,
			email: $ctrl.badge.EmailAddress,
			keywords: $ctrl.badge.id,
			phone: $ctrl.badge.PhoneNumber,
			allowEmptyAddress: true,
			status: "Active",
			tags: {
				Badge: $ctrl.badge.Id
			}
		} : $ctrl.$session.meta['BadgeScanProvider'] == 'XPress Leads' ? {
			companyName: $ctrl.badge.Company,
			address: $ctrl.badge.Address,
			address2: $ctrl.badge['Address 2'],
			city: $ctrl.badge.City,
			state: $ctrl.badge['State (Province)'],
			zip: $ctrl.badge.Zipcode,
			country: $ctrl.badge.Country,
			email: $ctrl.badge.Email,
			keywords: $ctrl.scannedBadgeNum,
			phone: $ctrl.badge.Phone,
			allowEmptyAddress: true,
			status: "Active",
			tags: {
				Badge: $ctrl.scannedBadgeNum
			}
		} : {};

		$ctrl.bus.send('CreateRetailer.json', request).then(function (created) {
			return $ctrl.prompt.edit(created.data).then(function (result) {
				$ctrl.match = result;
				$ctrl.bus.send('QueryRetailers.json?Id=' + result.id).then(function (res) {
					$ctrl.finished = true;
					$ctrl.matches = res.data.results;
					if ($ctrl.matches.length === 1) $ctrl.match = $ctrl.matches[0];
				});
			});
		});
	}

}


